import type { CustomerWithRelations } from "@sr-partner-portal/common";
import {
    createContext,
    type Dispatch,
    type SetStateAction,
    useContext,
} from "react";

interface CustomerContext {
    customer: CustomerWithRelations;
    setCustomer: Dispatch<SetStateAction<CustomerWithRelations>>;
}

export const CustomerContext = createContext<CustomerContext>({
    customer: null,
    setCustomer: () => undefined,
});
export const CustomerProvider = CustomerContext.Provider;
export const useCustomerContext = () => useContext(CustomerContext);
